<template>
  <div>
    {{labelname}}：
    <a-select
      show-search
      :placeholder="placeholder"
      style="max-width: 320px;width: 60%"
      :filter-option="filterOption"
      @change="handleChange"
      allowClear
      @popupScroll="handleScroll"
      @search="handleSearch"
      @select="handleSelect"
    >
      <template v-if="bigDataScroll">
        <a-select-option :value="item.val" v-for="(item,idx) in list_copy" :key="item.val"
                         v-if="idx >= startIdx && idx <= startIdx+100" >
          {{item.name}}
        </a-select-option>
      </template>
      <template v-else>
        <a-select-option :value="item.val" v-for="item in list" :key="item.val">
          {{item.name}}
        </a-select-option>
      </template>
    </a-select>
  </div>
</template>

<script>
import _ from 'lodash'

export default {
  name: 'selectcomponent',
  props: {
    list: {
      type: Array,
      default: () => ([])
    },
    labelname: {
      type: String,
      default: ''
    },
    placeholder: {
      type: String,
      default: ''
    },
    bigDataScroll: {
      type: Boolean,
      default: false
    }
  },
  data() {
    return {
      startIdx: 0,
      list_copy: []
    }
  },
  watch: {
    list(val){
     this.list_copy = val
    }
  },
  methods: {
    handleSelect(v){
      this.list_copy = this.list // 恢复搜索的副作用
    },
    handleSearch(val) {
      console.log(val,typeof val,this.list)
      if(val===''){
        this.list_copy = this.list
      }else{
        this.list_copy = this.list.filter(item => {
            return (item.name && item.name.includes(val))
          }
        )
        this.startIdx = 0
        console.log(this.list_copy)
      }
      // console.log(this.list)
    },
    handleScroll(e) {
      if (this.scrollfn) {
        this.scrollfn()
      } else {
        this.oldscrolltop = 0
        this.scrollfn = _.throttle(() => {
          // console.log(e.target.scrollTop, this.oldscrolltop)
          if (this.oldscrolltop > 2900) this.oldscrolltop = -1
          if (this.oldscrolltop < 100) this.oldscrolltop = 5000
          let diff = e.target.scrollTop - this.oldscrolltop
          let dir = diff > 0 ? '下滑' : '上滑' //1向下
          // this.startIdx = 1 + Math.floor(e.target.scrollTop / 30)
          // console.log(dir)
          if (e.target.scrollTop > 2900 && dir === '下滑') {
            this.startIdx = Math.min((this.list.length - 101), this.startIdx + 100)
            // this.oldscrolltop = -1
          }
          if (e.target.scrollTop < 100 && dir === '上滑') {
            this.startIdx = Math.max(0, this.startIdx - 10)
            // this.oldscrolltop = 3000
          }
          this.oldscrolltop = e.target.scrollTop
        }, 100)
        this.scrollfn()
      }
    },
    handleChange(value) {
      this.$emit('change', value)
    },
    filterOption(input, option) {
      return (
        option.componentOptions.children[0].text.toLowerCase().indexOf(input.toLowerCase()) >= 0
      )
    }
  }
}
</script>

<style scoped lang='less'>

</style>
